"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ReactTags = require("./react-tag-input/ReactTags");

require("./NameValuePairs.css");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var KeyCodes = {
  comma: 188,
  enter: 13
};
var delimiters = [KeyCodes.comma, KeyCodes.enter];

var NameValuePairs =
/*#__PURE__*/
function (_React$Component) {
  _inherits(NameValuePairs, _React$Component);

  function NameValuePairs() {
    _classCallCheck(this, NameValuePairs);

    return _possibleConstructorReturn(this, _getPrototypeOf(NameValuePairs).apply(this, arguments));
  }

  _createClass(NameValuePairs, [{
    key: "transformArrayIntoArrayOfObjects",
    value: function transformArrayIntoArrayOfObjects() {
      var pairs = this.props.pairs;
      return pairs.map(function (tag) {
        return {
          id: tag.name,
          name: tag.name,
          value: tag.value
        };
      });
    }
  }, {
    key: "handleDelete",
    value: function handleDelete(i) {
      var pairs = this.props.pairs;
      this.props.onPairsChange(pairs.filter(function (tag, index) {
        return index !== i;
      }));
    }
  }, {
    key: "handleAddition",
    value: function handleAddition(tag) {
      console.log(tag);
      this.props.onPairsChange([].concat(_toConsumableArray(this.props.pairs), [{
        name: tag.name,
        value: tag.value
      }]));
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      return _react["default"].createElement("div", null, _react["default"].createElement(_ReactTags.WithContext, {
        tags: this.transformArrayIntoArrayOfObjects(),
        handleDelete: function handleDelete(i) {
          return _this.handleDelete(i);
        },
        handleAddition: function handleAddition(tag) {
          return _this.handleAddition(tag);
        },
        delimiters: delimiters
      }));
    }
  }]);

  return NameValuePairs;
}(_react["default"].Component);

NameValuePairs.propTypes = {
  pairs: _propTypes["default"].arrayOf(_propTypes["default"].string),
  onPairsChange: _propTypes["default"].func
};
NameValuePairs.defaultProps = {
  pairs: null,
  onPairsChange: function onPairsChange() {}
};
var _default = NameValuePairs;
exports["default"] = _default;